export default __webpack_public_path__ + "static/media/byjus.b4307ce1.jpg";